import moment from 'moment';

export default () => {
  const todayNumber = moment().date();
  const numberOfDays = []
  for (let day = 1; day <= todayNumber; day++) {
    numberOfDays.push(day)
  };
  return numberOfDays;
};